<template>
  <div class="box addTreatmentProgramBox">
    <p class="xPadding titleModal">
      {{ $t(`treatmentProgram.steam.step2.title`) }}
    </p>
    <v-row
      v-for="(key, index) in keys"
      :key="index"
      class="xPadding"
    >
      <v-col class="py-0">
        <v-checkbox
          v-model="data[key]"
          class="check"
          :label="$t(`treatmentProgram.steam.step2.${key}`)"
          hideDetails
          @change="updateData"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="data.other"
      class="xPadding"
    >
      <v-col>
        <VTextField
          v-model="data.otherText"
          :label="$t('treatmentProgram.steam.step2.other')"
          outlined
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    components: {
        VTextField,
    },
    props: {
        injectionPoint: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
            keys: ['deaerator', 'hotwell', 'boiler', 'steam', 'other'],
        };
    },
    watch: {
        injectionPoint: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.injectionPoint) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { injectionPoint: this.data });
        },
    },
};
</script>
    <style lang="scss" scoped>
    .xPadding{
      padding: 0 6rem;
    }
    .check {
        border: 1px solid #8D969F;
        border-radius: 4px;
        padding: 10px 5px;
        height: 56px;
    }
    .box {
        margin: auto;
        width: 650px;
    }

    @media screen and (max-width: 600px) {
       .xPadding{
          padding: 0;
        }
        .text-field-transparent{
          margin-bottom:20px;
        }
    }

    @media screen and (max-width: 800px) {
       .addTreatmentProgramBox {
         width: 100% !important;
       }
    }

    </style>

    <style lang="scss">
      .addTreatmentProgramBox .v-input--selection-controls__input {
        margin-left: 5px;
      }
    </style>
